module.exports = __webpack_public_path__ + "img/appraisal.290aecec.svg";